var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe_container"},[_c('iframe',{attrs:{"frameborder":"0","width":"100%","height":"1000","src":"https://analytics.zoho.com/open-view/1403135000011366614/6629228dd819b0a7111d0ee54a09d511"}})])
}]

export { render, staticRenderFns }